import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiReadlistsService from '@/services/banzai-readlists.service'

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    Vue.prototype.$banzaiReadLists = new BanzaiReadlistsService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiReadLists: BanzaiReadlistsService;
  }
}
